import { appRoutes } from '../../path';
import { Feature, PermissionKey } from '../../utils/apollo/graphqlSchema';
import { IHeaderMenuItem } from './types';

interface IHeaderMainNavigationLink {
  label: string;
  url: string;
  requiredFeature?: Feature;
  permissionKeys?: PermissionKey[];
}

export const headerMainNavigationLinks: IHeaderMainNavigationLink[] = [
  {
    label: 'Home',
    url: appRoutes.home,
  },
  {
    label: 'Dashboards',
    url: appRoutes.dashboard.routePrefix,
    permissionKeys: [PermissionKey.DashboardRead],
  },
  {
    label: 'Reports',
    url: appRoutes.report.routePrefix,
    permissionKeys: [PermissionKey.AnalysisRead],
  },
  {
    label: 'Cohorts',
    url: appRoutes.cohorts.routePrefix,
    permissionKeys: [PermissionKey.CohortReportRead, PermissionKey.CohortRead],
  },
  {
    label: 'Workspaces',
    url: appRoutes.workspaces.routePrefix,
    requiredFeature: Feature.Workspace,
  },
];

export const dataManagementDropdownLinks: IHeaderMenuItem[] = [
  {
    label: 'Data Modeler',
    icon: 'database',
    to: '/modeler',
    description: 'Design and manage your data models',
    requiredFeature: Feature.DataModeler,
    permissionKeys: [PermissionKey.DataModelView],
  },
  {
    label: 'Dictionary',
    icon: 'book-open-text',
    to: '/dictionary',
    description: 'Explore and define data definitions',
  },
  {
    label: 'Schedule',
    icon: 'schedule',
    to: '/schedules',
    description: 'Manage and schedule data tasks',
    permissionKeys: [
      PermissionKey.DashboardScheduleRead,
      PermissionKey.AnalysisScheduleRead,
    ],
  },
  {
    label: 'Incidents',
    icon: 'incidents',
    to: '/incidents',
    description: 'Track and resolve data incidents',
  },
];
